import { ROUTER_PATH, ROUTER_TITLES } from '@/router/constants';
import InquiryPage from '@/pages/inquiry/InquiryPage';
import PartnershipPage from '@/pages/inquiry/partnership/PartnershipPage';
import ServicePage from '@/pages/inquiry/service/ServicePage';

export const InquiryRouter = {
	element: <InquiryPage />,
	children: [
		{
			path: ROUTER_PATH.INQUIRY.PARTNERSHIP,
			element: <PartnershipPage />,
			title: ROUTER_TITLES.INQUIRY.PARTNERSHIP
		},
		{
			index: true,
			path: ROUTER_PATH.INQUIRY.SERVICE,
			element: <ServicePage />,
			title: ROUTER_TITLES.INQUIRY.SERVICE
		}
	]
};
